// This is the providers wrapper. Add any additional providers in the chain here.
import { ListsProvider } from "hooks/ListsContext";
import React from "react";

import { ReduxProvider } from "../ReduxProvider";

export const Provider: React.FC = ({ children }) => (
  <ReduxProvider>
    <ListsProvider>{children}</ListsProvider>
  </ReduxProvider>
);
